import { tasksApi } from 'modules/cm/api';
import { CaseId } from 'modules/cm/api/cases/types';
import { Dispatch } from 'redux';
import { apiToDomain } from '../mappers/toDomain';
import { actions } from '../store';
import { GetState } from '../../store/cases/types';

const getTasks = (caseId: CaseId) => {
  return async (dispatch: Dispatch, getState: GetState) => {
    dispatch(actions.startGettingTasks());
    try {
      const { data } = await tasksApi(caseId).getAll();
      const tasks = apiToDomain(data);

      dispatch(actions.gettingTaskFinish(tasks));
    } catch (error) {}
  };
};

export default getTasks;
